import { atom } from 'recoil';
import { getConfigVariable } from '../../fn/Config';

// Get the default location component to use
const LOCATION_VERSION = getConfigVariable('LOCATION_VERSION');

export const locationVersion = atom({
  key: 'locationVersion',
  default: LOCATION_VERSION,
});
